var React = require('react');

function DeliveryInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M2 9V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12H3a1 1 0 0 1-1-1v-3m14.012-6h2.891a2 2 0 0 1 1.442.614l2.097 2.18A2 2 0 0 1 23 11.181V17h-7l.012-10z","key":0}),React.createElement("circle",{"cx":"6.5","cy":"18.5","r":"1.5","key":1}),React.createElement("circle",{"cx":"19.5","cy":"18.5","r":"1.5","key":2}),React.createElement("path",{"d":"M1 9h7","key":3})]));
}

DeliveryInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = DeliveryInline;

DeliveryInline.default = DeliveryInline;
